(function () {
  function initMembershipCTA() {
    const sections = document.querySelectorAll('.membership-cta-section');
    sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      // ── Element References ──
      const ctaContainer = section.querySelector('.membership-cta__container');
      const dashboardContainer = section.querySelector('.membership-cta__dashboard');
      const overlineEl = section.querySelector('.membership-cta__dashboard-overline');
      const subheadingEl = section.querySelector('.membership-cta__dashboard-subheading');

      // ── Customer Tag Detection ──
      const customerTags = (section.getAttribute('data-customer-tags') || '').toLowerCase();
      const hasCustomer = section.hasAttribute('data-customer-logged-in');
      const hasVipTag = customerTags.includes('inveterate tier: vip') || customerTags.includes('inveterate-tier: vip') || customerTags.includes('vip');
      const hasInsiderTag = customerTags.includes('inveterate tier: insider') || customerTags.includes('inveterate-tier: insider') || customerTags.includes('insider');


      // ── Toggle Guest / Dashboard Views ──
      if (hasCustomer && ctaContainer && dashboardContainer) {
        ctaContainer.classList.add('hidden');
        dashboardContainer.classList.remove('hidden');
      } else if (ctaContainer && dashboardContainer) {
        ctaContainer.classList.remove('hidden');
        dashboardContainer.classList.add('hidden');
      }

      // ── Refine tier label from Inveterate JS object (async) ──
      // Liquid already sets the correct state from customer tags,
      // but Inveterate's JS object may provide a more precise tier name.
      if (hasCustomer) {
        refineTierFromInveterate();
      }

      async function refineTierFromInveterate() {
        for (let i = 0; i < 15; i++) {
          if (window.inveterate && window.inveterate.properties) {
            const customer = window.inveterate.properties.customer;
            if (customer) {
              const tier = (customer.tier || '').toUpperCase();
              const isVIP =
                tier.includes('VIP') ||
                (customer.subscriptions &&
                  customer.subscriptions.some(
                    function (s) {
                      return (s.tier || '').toUpperCase().includes('VIP') && s.status === 'active';
                    }
                  ));
              const isMember = isVIP || customer.isMember || customer.status === 'active' || (customer.subscriptions && customer.subscriptions.length > 0);

              if (isMember) {
                if (overlineEl) {
                  overlineEl.textContent = isVIP ? 'DORADO REWARDS \u00b7 VIP' : 'DORADO REWARDS \u00b7 MEMBER';
                }

                // Update subheading
                if (subheadingEl) {
                  var freeText = subheadingEl.getAttribute('data-free-text');
                  var vipText = subheadingEl.getAttribute('data-vip-text');
                  subheadingEl.textContent = isVIP ? vipText : freeText;
                }
              }

              // If Inveterate says VIP but Liquid didn't render VIP buttons,
              // dynamically swap the dashboard action buttons
              if (isVIP && !hasVipTag) {
                swapToVipDashboard();
              }
            }
            break;
          }
          await new Promise(function (r) {
            setTimeout(r, 200);
          });
        }
      }

      function swapToVipDashboard() {
        var actionsEl = section.querySelector('.membership-cta__dashboard-actions');
        if (!actionsEl) return;

        var accountUrl = section.getAttribute('data-account-url') || 'https://account.dorado.com/profile';

        // Replace insider buttons with VIP dashboard buttons
        actionsEl.innerHTML =
          '<a href="' + accountUrl + '" class="membership-cta__button membership-cta__button--vip" data-action="view-credit">VIEW MY CREDIT</a>' +
          '<a href="' + accountUrl + '" class="membership-cta__button membership-cta__button--free" data-action="my-membership">MY MEMBERSHIP</a>';
      }

      // ── VIP Product Quantity Guard ──
      // Enforce max quantity of 1 for VIP membership products in the cart
      async function enforceVipQuantity() {
        try {
          var response = await fetch('/cart.js');
          if (!response.ok) return;
          var cart = await response.json();

          if (!cart.items) return;

          cart.items.forEach(function (item) {
            var isVip =
              (item.handle && item.handle.indexOf('inveterate') > -1) ||
              (item.title && item.title.toLowerCase().indexOf('vip') > -1) ||
              (item.properties &&
                (item.properties._inveterate_subscription === 'true' ||
                  item.properties._inveterate_subscription === true));

            if (isVip && item.quantity > 1) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 1 }),
              }).then(function () {
                if (
                  window.Rebuy &&
                  window.Rebuy.Cart &&
                  typeof window.Rebuy.Cart.getCart === 'function'
                ) {
                  window.Rebuy.Cart.getCart(true);
                }
                document.dispatchEvent(new CustomEvent('cart:updated'));
              });
            }
          });
        } catch (e) {
          console.warn('[MembershipCTA] Error enforcing VIP quantity:', e);
        }
      }

      // Run quantity guard on load
      enforceVipQuantity();

      // Listen for cart changes to keep quantity enforced
      document.addEventListener('cart:updated', enforceVipQuantity);
      document.addEventListener('rebuy:cart.change', enforceVipQuantity);

      // ── Smooth Scroll for Footer "See Perks" Links ──
      var footerLinks = section.querySelectorAll('.membership-cta__footer-link');
      footerLinks.forEach(function (footerLink) {
        footerLink.addEventListener('click', function (e) {
          var href = footerLink.getAttribute('href');
          if (href && href.startsWith('#')) {
            var target = document.querySelector(href);
            if (!target && href === '#membership-comparison') {
              target = document.querySelector('.membership-comparison');
            }
            if (target) {
              e.preventDefault();
              var headerOffset = 100;
              var elementPosition = target.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: 'smooth',
              });
            }
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMembershipCTA);
  } else {
    initMembershipCTA();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (
      (e.target && e.target.classList.contains('membership-cta-section')) ||
      (e.target && e.target.querySelector('.membership-cta-section'))
    ) {
      initMembershipCTA();
    }
  });
})();
